const URL = "https://dlxmrqrs22.execute-api.us-east-1.amazonaws.com/live/";
const PROFILE_URL = URL + "profiles";
const QDB_URL =
  "https://srwwsn660e.execute-api.us-east-1.amazonaws.com/staging/items/all";

const SPLIT_URL = URL + "split/score";
// const REPORTS_URL = URL + "score";
// const QDB_URL =
//   "https://2cwkxttpej.execute-api.us-east-1.amazonaws.com/Prod/qdb/";
const MC_URL =
  "https://2cwkxttpej.execute-api.us-east-1.amazonaws.com/Prod/montecarlo";

const CANCEL_SUB_URL = URL + "payment";

//const NEWPOSTURL = "localhost:8000/profiles";
//const LOCALURL = "localhost:8000/profiles";
function log(text, flag) {
  const logAll = false;
  if (flag === true || logAll === true) {
    // console.log(text);
  }
}

// const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default function newProfileReq(formDataObject, userNameKey, email) {
  const logNewProfiles = false;
  const data = {
    Email: email,
    QFuserID: userNameKey,
    formData: formDataObject,
    Settings: {
      site: window.location.href,
    },
  };
  log("Sending fetch request: " + JSON.stringify(data), logNewProfiles);
  fetch(PROFILE_URL, {
    method: "POST",
    headers: {
      Accept: "application.json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      log("newProfileReq Response:" + JSON.stringify(response), logNewProfiles);
      return response.json();
    })
    .then((data) => {
      log("newProfileReq Success:" + JSON.stringify(data), logNewProfiles);
      window.location.href = "/";
    })
    .catch((error) => {
      console.error("newProfileReq Error:", JSON.stringify(error));
    });
}

export function getProfileReq(userNameKey, callback) {
  //  fetch(`${PROFILE_URL}?q=${userNameKey}`)
  fetch(`${PROFILE_URL}?q=${userNameKey}`)
    .then((response) => {
      return response.json();
    })
    .then(callback)
    .catch((err) => console.log("err :>> ", err));
}

export function getQDBReq(callback) {
  fetch(`${QDB_URL}`)
    .then((response) => {
      return response.json();
    })
    .then(callback);
}

export function getMC(data, callback) {
  fetch(MC_URL, {
    method: "POST",
    headers: {
      Accept: "application.json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      log("getMC Response:" + JSON.stringify(response), false);
      return response.json();
    })
    .then((data) => {
      log("getMCSuccess:" + JSON.stringify(data), false);
      callback(data);
    })
    .catch((error) => {
      console.error("getMC Error:", JSON.stringify(error));
    });
}

export function cancelSUb(userNameKey, SubID, callback) {
  const data = {
    QFuserID: userNameKey,
    SubID: SubID,
  };
  fetch(CANCEL_SUB_URL, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data }),
  })
    .then((response) => response.json())
    .then((data) => {
      log("cancelSUb Success:" + data, true);
    })
    .then(callback)
    .catch((error) => {
      console.error("cancelSUb Error:", JSON.stringify(error));
    });
}

export function setActiveProfReq(userNameKey, ActiveProfIndex, callback) {
  const logSetActive = true;
  const data = {
    QFuserID: userNameKey,
    updateKey: "LastActive",
    ActiveProfIndex: ActiveProfIndex,
  };
  fetch(URL + "user", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data }),
  })
    .then((response) => response.json())
    .then((data) => {
      log("setActiveProfReq Success:" + JSON.stringify(data), logSetActive);
    })
    .then(callback)
    .catch((error) => {
      console.error("setActiveProfReq Error:", JSON.stringify(error));
    });
}

export function AddProfileReq(
  formDataObject,
  userNameKey,
  updateKey,
  userDataObject,
  isEdit,
  callback
) {
  const logAddProfiles = true;
  log(`sending fetch request- Add Profile to :${userNameKey}`, logAddProfiles);

  const data = {
    QFuserID: userNameKey,
    formData: formDataObject,
    updateKey: updateKey,
    userDataObject: userDataObject,
    isEdit: isEdit,
  };
  log("Sending Add Profile request: " + JSON.stringify(data), logAddProfiles);
  fetch(PROFILE_URL, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data }),
  })
    .then((response) => response.json())
    .then((data) => {
      log("AddProfileReq Success:" + JSON.stringify(data), logAddProfiles);
      callback();
    })
    .catch((error) => {
      console.error("AddProfileReq Error:", error);
    });
}

export function AddReport(
  formDataObject,
  userNameKey,
  updateKey,
  userDataObject,
  dev = false
) {
  const logAddReport = true;
  const today = new Date();
  let yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  let hrs = today.getHours();
  let min = today.getMinutes();
  let sec = today.getSeconds();
  let Profiles = userDataObject.Profiles;
  //console.log(Profiles);
  const ArrayIDX = Profiles.findIndex((object) => {
    return object.Name === updateKey.Name;
  });
  //console.log(ArrayIDX);
  let now = `${yyyy}X${mm}X${dd}X${hrs}X${min}X${sec}`;

  let ActiveProfileObj = {
    DOB: updateKey.DOB,
    Latest: updateKey.Latest,
    Gender: updateKey.Gender,
    Age: updateKey.Age,
    Name: updateKey.Name,
  };
  ActiveProfileObj.History =
    updateKey.History === undefined ? undefined : "Has History";
  const data = {
    QFuserID: userNameKey,
    formData: formDataObject,
    ActiveProfile: ActiveProfileObj,
    ArrayIDX: ArrayIDX,
    timeStamp: now,
  };
  log("Sending Add Report request: " + JSON.stringify(data), logAddReport);
  // console.log("test");
  // console.log(JSON.stringify(data));
  if (dev) {
    exportReport(data, `${ActiveProfileObj.Name}_${data.timeStamp}`);
  }
  // fetch(REPORTS_URL, {
  fetch(SPLIT_URL, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data }),
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      if (data.Message === "SUCCESS") {
        window.location.href = "/";
      } else {
        // window.location.href = "/error";
        // console.log(JSON.stringify(data));
      }
    })
    .catch((error) => {
      console.error("AddReport Error:", JSON.stringify(error));
    });
}

function exportReport(userInfo, fileName) {
  const fileData = JSON.stringify(userInfo);
  const blob = new Blob([fileData], { type: "text/plain" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = `Report Test - ${fileName}.txt`;
  link.href = url;
  link.click();
}
